import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core'
import { moveItemInArray } from '@angular/cdk/drag-drop'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'

@Component({
	selector: 'glossary',
	templateUrl: './glossary.component.html',
	styleUrls: ['./glossary.component.scss']
})

export class GlossaryComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	loading = true
	error = false
	
	@Input() id = 0
	@Input() course = -1
	@Input() category = -1
	@Input() multitransl = false
	@Input() transl = 'es'

	title = ''
	unit = 0
	words: any[] = []
	wordsNum = 0

	import = false
	importType = ''
	importWords: any[] = []
	importWordsNum = 0
	importReset = false
	importing = false
	importSuccess = false
	importError = false
	wordsNotFound = false

	importCategory = -1
	importCourse = -1
	importUnit = -1
	importCategories: any[] = []
	importCourses: any[] = []
	importUnits: any[] = []

	getGlossarySub = new Subscription
	getCategoriesSub = new Subscription
	getCategoryCoursesSub = new Subscription
	getCourseUnitsSub = new Subscription
	getUnitGlossarySub = new Subscription
	addWordSub = new Subscription
	editWordSub = new Subscription
	moveWordSub = new Subscription
	deleteWordSub = new Subscription
	importWordsSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter
	
	constructor(private dataService: ApiService, private renderer: Renderer2) {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {}

	ngOnChanges(): void {
		this.getGlossary(this.id)
	}

	ngOnDestroy(): void {
		this.getGlossarySub?.unsubscribe()
		this.getCategoriesSub?.unsubscribe()
		this.getCategoryCoursesSub?.unsubscribe()
		this.getCourseUnitsSub?.unsubscribe()
		this.getUnitGlossarySub?.unsubscribe()
		this.addWordSub?.unsubscribe()
		this.editWordSub?.unsubscribe()
		this.moveWordSub?.unsubscribe()
		this.deleteWordSub?.unsubscribe()
		this.importWordsSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	showEdit(event: Event) {
		let span = event.currentTarget as HTMLSpanElement
		let edit = span.nextElementSibling as HTMLElement
		this.renderer.addClass(span, 'd-none')
		this.renderer.removeClass(edit, 'd-none')
		edit.focus()
	}

	hideEdit(event: Event) {
		let edit = event.currentTarget as HTMLElement
		let span = edit.previousElementSibling as HTMLSpanElement
		this.renderer.addClass(edit, 'd-none')
		this.renderer.removeClass(span, 'd-none')
	}

	getGlossary(glossary: number) {
		this.loading = true
		this.error = false
		this.id = glossary
		this.getGlossarySub = this.dataService.getGlossary(glossary, this.multitransl, this.transl)
		.subscribe({
			next: (glossary) => {
				// console.log(glossary)
				this.loading = false
				this.error = false
				this.title = glossary.name
				this.unit = glossary.unit
				this.words = glossary.words
				this.wordsNum = glossary.words.length
			},
			error: (_e) => {
				// console.log(e)
				this.loading = false
				this.error = true
			},
		})
	}

	getCategories() {
		this.importCategories = []
		this.getCategoriesSub = this.dataService.getCategories()
		.subscribe({
			next: (categories) => {
				this.importCategories = categories
			},
			error: (_e) => {
				// console.log(e)
			}
		})
	}
	
	getCategoryCourses(category: number) {
		if (category <= 0) return

		this.importCourses = []
		this.getCategoryCoursesSub = this.dataService.getCategoryCourses(category)
		.subscribe({
			next: (courses) => {
				courses.forEach((course: any) => {
					let courseID = course.id
					if (courseID != this.course) {
						this.importCourses.push({
							'id': courseID,
							'name': course.name,
						})
					}
				})
			},
			error: (_e) => {
				// console.log(e)
			}
		})
	}

	getCourseUnits(course: number) {
		if (course <= 0) return

		this.importUnits = []
		this.getCourseUnitsSub = this.dataService.getCourseUnits(course)
		.subscribe({
			next: (units) => {
				units.forEach((unit: any) => {
					let unitID = +unit.id.split('_').pop()
					if (unitID != this.unit) {
						this.importUnits.push({
							'id': unitID,
							'name': unit.text,
							'glossary': undefined,
						})
					}
				})
			},
			error: (_e) => {
				// console.log(e)
			}
		})
	}

	addWord() {
		let word = 'Nueva palabra'
		let definition = 'Definición'
		let position = this.words.length

		this.addWordSub = this.dataService.addWord(this.id, word, definition, position)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.getGlossary(this.id)
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	editWord(event: Event, wordId: number) {
		let input = event.target as HTMLInputElement
		let span = input.previousElementSibling as HTMLSpanElement
		let word = input.value
		this.renderer.setProperty(span, 'textContent', word)
		this.renderer.addClass(input, 'd-none')
		this.renderer.removeClass(span, 'd-none')

		// console.log(wordId)
		// console.log(word)
		this.editWordSub = this.dataService.editWord(wordId, word, undefined, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	editWordDefinition(event: Event, wordId: number) {
		let input = event.target as HTMLInputElement
		let span = input.previousElementSibling as HTMLSpanElement
		let definition = input.value
		this.renderer.setProperty(span, 'textContent', definition)
		this.renderer.addClass(input, 'd-none')
		this.renderer.removeClass(span, 'd-none')

		this.editWordSub = this.dataService.editWord(wordId, undefined, definition, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	moveWord(index: number, direction: string) {
		// console.log(index)
		// console.log(direction)

		let newIndex = 0
		if (direction === 'up' && index > 0) newIndex = index - 1
		else if (direction === 'down' && newIndex < this.words.length) newIndex = index + 1
		
		// console.log(newIndex)
		moveItemInArray(this.words, index, newIndex)
		// console.log(this.words)

		this.moveWordSub = this.dataService.editWordPositions(this.words)
		.subscribe({
			next: (_data) => {
				// console.log(data)
			},
			error: (_e) => {
				// console.log(e)
			},
		})

		return false
	}

	deleteWord(wordIndex: number) {
		Swal.fire({
			title: '¿Seguro?',
			text: '¿Está seguro de querer borrar esta palabra?',
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return
			
			// console.log(wordIndex)
			let wordId = this.words[wordIndex].id
			let wordPos = this.words[wordIndex].position
			// console.log(wordId) 
			this.words.splice(wordIndex, 1)
	
			// console.log(this.words)
			this.deleteWordSub = this.dataService.deleteWord(wordId, wordPos, this.id)
			.subscribe({
				next: (_data) => {
					// console.log(data)
				},
				error: (_e) => {
					// console.log(e)
				},
			})
		})

		return false
	}

	resetImport() {
		this.importing = false
		this.importSuccess = false
		this.importError = false
		this.importType = ''
		this.importCategory = -1
		this.importCourse = -1
		this.importUnit = -1
		this.importCategories = []
		this.importCourses = []
		this.importUnits = []
		this.importWords = []
		this.importWordsNum = 0
		this.importReset = false
	}

	toggleImport() {
		this.import = !this.import
		if (!this.import) {
			this.resetImport()
			this.getGlossary(this.id)
		}
	}

	toggleImportType() {
		// console.log(this.importType)
		// this.resetImport()
		if (this.importType == 'unit') {
			this.importCourse = this.course
			this.importUnit = -1
			this.getCourseUnits(this.importCourse)
		} else if (this.importType == 'courseUnit') {
			this.importCategory = this.category
			this.getCategories()
			this.importCourse = -1
			this.getCategoryCourses(this.importCategory)
			this.importUnit = -1
			this.importUnits = []
		}
	}

	selectUnitGlossary() {
		console.log(this.importUnit)

		this.getUnitGlossarySub = this.dataService.getUnitGlossary(this.importUnit)
		.subscribe({
			next: (glossary) => {
				let currentUnit = this.importUnits.find((unit: any) => {
					return unit.id == this.importUnit
				})
				let unitHasGlossary = glossary.id != undefined
				currentUnit.glossary = unitHasGlossary
				if (unitHasGlossary) {
					let glossaryWords = glossary.words
					this.importWords = glossaryWords
					this.importWordsNum = glossaryWords.length
				} else {
					Swal.fire('Error', 'La unidad seleccionada no tiene glosario.', 'error')
					this.importUnit = -1
					this.importWords = []
					this.importWordsNum = 0
					return
				}
			},
			error: (_e) => {
				// console.log(e)
			}
		})
	}

	csvUpload(event: Event) {
		// console.log(event)
		let input = event.target as HTMLInputElement
		let file = input.files?.item(0)!
		// console.log(file)

		this.importWords = []
		this.importWordsNum = 0

		let type = file.type
		if (type != "text/csv" && type != "application/vnd.ms-excel") {
			Swal.fire('Error', 'Por favor, suba un archivo CSV.', 'error')
			return
		}

		let reader = new FileReader()
		reader.onload = event => {
			let text = event.target?.result?.toString().trim() ?? ""
			let lines = text.split("\r\n")
			lines.forEach((line) => {
				let lineArr = []
				lineArr = line.split(";", 2)
				if (lineArr.length < 2) lineArr = line.split(",", 2)
				console.log(line)
				console.log(lineArr)
				if (lineArr.length == 2) {
					let wordObj = {
						'word': lineArr[0].trim(),
						'definition': lineArr[1].trim()
					}
					this.importWords.push(wordObj)
					this.importWordsNum++
				}
			})

			this.wordsNotFound = this.importWordsNum == 0
		}
		reader.readAsText(file)
	}

	glossaryImport() {
		console.log(this.importType)
		console.log(this.importWords)
		console.log(this.importWordsNum)
		console.log(this.importReset)

		this.importing = true
		this.importSuccess = false
		this.importError = false

		let position = this.importReset ? 0 : this.wordsNum - 1
		this.importWordsSub = this.dataService.importWords(this.id, this.importWords, position, this.importReset)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.importing = false
				this.importSuccess = true
				this.importError = false
			},
			error: (_e) => {
				// console.log(e)
				this.importing = false
				this.importSuccess = false
				this.importError = true
			},
		})
	}

	glossaryExport() {
		let csv = ''
		this.words.forEach((word) => {
			csv += word.word + ';' + word.definition + '\r\n'
		})

		let link = document.createElement('a')
		link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
		link.target = '_blank'
		link.download = 'glosario.csv'
		link.click()
	}

}